module.exports = __webpack_public_path__ + "img/platform_ser_zhjr_02@2x.a1f036df.png";